





































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import ApiHelper from 'api-helper';
import Toast from '@common/helpers/toast';
import { Patient } from '@/models/patient';
import { UserTreatment } from '@/models/user-treatment';

@Component({
  components: {},
})
export default class MemoPopup extends Vue {
  @Prop({ required: true }) currentChannelUser!: Patient;
  @Prop({ required: true }) activeTreatment!: UserTreatment;

  private content: string = '';
  private isSubmitting: boolean = false;
  private editingMemoId: number | null = null;

  public show(memo?: { id: number; content: string }): void {
    this.content = memo ? memo.content : '';
    this.editingMemoId = memo ? memo.id : null;
    if (this.$refs.memoForm) {
      (this.$refs.memoForm as any).reset();
    }
    this.$modal.show('memoForm');
  }

  private hide(): void {
    this.$modal.hide('memoForm');
  }

  private async saveMemo(): Promise<void> {
    const isValid = await (this.$refs.memoForm as any).validate();
    if (!isValid) {
      return;
    }

    this.isSubmitting = true;
    try {
      if (this.editingMemoId !== null) {
        await ApiHelper.getApi('DoctorMouthApi').updateFeedback(
          this.editingMemoId,
          { type: 'memo', content: this.content, user_id: this.currentChannelUser.id, user_treatment_id: this.activeTreatment.id },
        );
      } else {
        await ApiHelper.getApi('PatientV2Api').createFeedback(
          this.currentChannelUser.id,
          {
            type: 'memo',
            content: this.content,
            user_treatment_id: this.activeTreatment.id,
          },
        );
      }
      this.hide();
      this.$emit('savedMemo');
    } catch (error) {
      Toast.error(error?.response?.data?.message || 'エラーが発生しました');
    } finally {
      this.isSubmitting = false;
    }
  }
}
